// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"493":"cf2027768f42937a","534":"d6bc755c5bcdbcf0"}[chunkId] + ".js";
};